// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

import { Icon } from "metabase/ui";

interface SidebarButtonProps {
  isSmallAppBar?: boolean;
  isNavBarEnabled?: boolean;
  isLogoVisible?: boolean;
}

export const SidebarButton = styled.button<SidebarButtonProps>`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  padding: ${({ isSmallAppBar }) => (isSmallAppBar ? `0.5rem 0` : `1rem 0`)};
`;

interface SidebarIconProps {
  isLogoVisible?: boolean;
  isNavBarOpen?: boolean;
  isSmallAppBar?: boolean;
}

export const SidebarIcon = styled(Icon, {
  shouldForwardProp: (propName) =>
    propName !== "isLogoVisible" &&
    propName !== "isNavBarOpen" &&
    propName !== "isSmallAppBar",
})<SidebarIconProps>`
  display: block;
  color: ${(props) =>
    props.isNavBarOpen
      ? "var(--mb-color-text-white)"
      : "var(--mb-color-brand)"};

  &:hover {
    color: ${(props) =>
      props.isNavBarOpen
        ? "var(--mb-color-text-white)"
        : "var(--mb-color-brand)"};
  }
`;
